import {observable, action, runInAction, computed} from 'mobx'
import {message} from 'antd'
import {get, json} from '../utils/ajax'
import {AESEncrypt} from '../utils/Utils'
import * as Session from '../utils/Session'

class AppStore {
    // 页面展示
    @observable collapsed
    @observable leftMenuMode
    @observable loading
    // 后台数据
    @observable isLogin
    @observable leftMenu//个人权限菜单
    @observable platformLeftMenu//后台全部权限
    @observable userInfo
    @observable list
    //前台数据
    @observable topMenu //个人权限菜单
    @observable platformTopMenu //前台全部权限

    //个人信息
    @observable modal
    @observable forms
    @observable loginInfo
    // @observable mustSet   //'强制修改密码'
    @observable panes         //标签页
    @observable activeKey     //当前活动的标签页
    @observable route
    @observable selectedKeys
    @observable sideArr  //后台首页侧边栏数据
    @observable addClassName  //判断是否添加类名
    @observable loginLoading
    @observable numberOfReplies //回复数量

    @observable password //保存密码
    @observable editPassword //主动修改密码

    constructor() {
        this.collapsed = false
        this.leftMenuMode = 'inline'
        this.isLogin = !!Session.isAuthenticated()
        this.loading = false
        this.leftMenu = []
        this.userInfo = {user: {}, company: {}}
        this.list = [1, 2, 3, 4]
        this.forms = {}
        this.topMenu = []
        this.platformTopMenu = []
        this.platformLeftMenu = []
        this.loginInfo = ''
        this.company = JSON.parse(process.env.REACT_APP_COMPANY)
        // this.mustSet=false
        this.panes = []
        this.activeKey = ''
        this.route = ''
        this.selectedKeys = []
        this.sideArr = []
        this.addClassName = ''
        this.numberOfReplies = ''
        this.password = ''
        this.editPassword = false
    }


    @action login = async values => {
        try {
            let loginForm = values
            loginForm.password = AESEncrypt(loginForm.password, '1111222233334444')
            const res = await json.post(`${process.env.REACT_APP_API_URL}/login:pc`, loginForm)
            if (res.status) {
                Session.authenticateSuccess(res.data.token)
                runInAction(() => {
                    this.isLogin = true
                })
            } else {
                message.error(res.msg)
            }
        } catch (error) {
            message.error(error)
        }
    }

    @action externalInterfaceLogin = async (values)=> {
        try {
            this.loginLoading = true
            if (values) {
                Session.authenticateSuccess(values)
                runInAction(() => {
                    this.isLogin = true
                    this.loginLoading = false
                })
            }
            runInAction(() => {
                this.loginLoading = false
            })
        } catch (error) {
            message.error(error)
        }
    }

    @action logout = async () => {
        try {
            await get(`${process.env.REACT_APP_API_URL}/logout`)
            Session.logout()
            runInAction(() => {
                localStorage.removeItem('status');
                localStorage.removeItem('password');
                this.isLogin = false
            })
        } catch (error) {
            message.error(error)
        }
    }
    /**
     * 用户菜单权限
     * @param platformId
     * @returns res [tree]
     */
    @action initSiderMenu = async (platformId) => {
        try {
            if (this.isLogin == false) {
                return
            }
            const res = await get(`${process.env.REACT_APP_API_URL}/Menu/platformId/${platformId}`)
            if (res.status) {
                runInAction(() => {
                    platformId === this.company.backend && (this.leftMenu = res.data)
                    platformId === this.company.frontend && (this.topMenu = res.data)
                })
            }
        } catch (error) {
            message.error(error)
        }
    }

    /**
     * 平台所有菜单权限
     * @param platformId
     * @returns res [tree]
     */
    @action initPlatformMenu = async (platformId) => {
        if (this.isLogin == false) {
            return
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/role/permissions/platformId/${platformId}`)
        if (res.status) {
            runInAction(() => {
                platformId === this.company.backend && (this.platformLeftMenu = res.data)
                platformId === this.company.frontend && (this.platformTopMenu = res.data)
            })
        }
    }

    @action initUserInfo = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/userInfo`)
        // const res1 = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/answerPlatform/answerCenter/numberOfQueryResponses`)
        if (res.status) {
            runInAction(() => {
                this.userInfo = res.data
                localStorage.setItem('status', JSON.stringify(res.data.user));
                // this.numberOfReplies = res1
            })
        }
    }

    @action
    addFrontEndModuleRecord = async (values) => {
        let search = {
            userName: this.userInfo.user.loginName,
            model: values
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDeskOperationRecord/add`, search)
    }

    @action.bound
    collapse() {
        this.collapsed = !this.collapsed
        this.leftMenuMode = this.collapsed ? 'vertical' : 'inline'
    }

    @action
    demo = () => {
        const a = this.list.filter(item => item > 1).map(item => item + 100)
        runInAction(() => {
            this.list = a
        })
    }

    @computed
    get fields() {
        let fields = {
            // loginName: {value: this.forms.loginName},
            // name: {value: this.forms.name},
            oldPassword: {value: this.forms.oldPassword},
            password: {value: this.forms.password},
            passwordConfirm: {value: this.forms.passwordConfirm},
            // phone: {value: this.forms.phone},
            // email: {value: this.forms.email},
        }
        return fields
    }

    @action.bound
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            // loginName: fields.loginName.value,
            // name: fields.name.value,
            oldPassword: fields.oldPassword.value,
            password: fields.password.value,
            passwordConfirm: fields.passwordConfirm.value,
            // phone: fields.phone.value,
            // email: fields.email.value,
        }
        this.forms = forms
    }

    /**
     * 编辑个人信息
     */
    @action editInfo = () => {
        this.forms = {
            password: '',
            newPassword: '',
            passwordConfirm: '',
        }
        this.modal = 'show'
        this.editPassword =true
        // this.mustSet=false
    }


    @action judgePassword=()=>{
       const password = this.validateString(this.password)
        if(!password){
            this.modal = 'show'
            this.editPassword =false
        }else{
            localStorage.setItem('password','合格');
        }
      console.log(password,'this.passwordpasswordpasswordpassword')
      console.log(this.password,'this.password')


}

    @action validateString(a) {
        // 检查长度是否大于8
        if (a.length <= 8) {
            return false;
        }
        // 定义正则表达式来检查大写字母、小写字母、数字和符号
        const hasUpperCase = /[A-Z]/.test(a);
        const hasLowerCase = /[a-z]/.test(a);
        const hasNumber = /\d/.test(a);
        const hasSymbol = /[!@#$%^&*()\-_=+{};:,<.>?\/\\|`~]/.test(a); // 这是一个示例符号集，你可以根据需要调整
        // 如果所有条件都满足，则返回true ，否则返回 false
        return hasUpperCase && hasLowerCase && hasNumber && hasSymbol;
    }


    @action save = async () => {
        let num;
        runInAction(() => {
            this.loading = true
        })
        let search = {}
        search.search = this.userInfo.user.loginName;
        const arr = await json.get(`${process.env.REACT_APP_API_URL}/users:search`, search)
        if (json.isError(arr)) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        for (let i = 0; i <= arr.content.length - 1; i++) {
            if (arr.content[i].loginName === this.userInfo.user.loginName) {
                num = arr.content[i].id;
            }
        }
        const res = await json.put(`${process.env.REACT_APP_API_URL}/user:updatePassword/${num}?password=${this.forms.password}&oldPassword=${this.forms.oldPassword}`)
        if (res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            message.error('旧密码输入错误');
            return
        }
        localStorage.setItem('password','合格');
        message.success('修改密码成功！')
        this.initUserInfo()
        runInAction(() => {
            this.loading = false;
            this.modal = 'hide'
        })
    }


    /**
     *取消编辑
     */
    @action.bound
    cancelEdit() {
        this.loading = false
        this.modal = 'hide'
    }

    /**
     * 获取东风登陆参数
     * @returns {Promise.<void>}
     */
    @action getdfacInfo = async () => {
        if (this.isLogin == false) {
            return
        }
        const df = await get(`${process.env.REACT_APP_API_URL}/onestep/base/depc/getloginInfo`)
        if (!df.status) {
            return
        }
        runInAction(() => {
            this.loginInfo = 'name=' + df.data.name +
                '&timestamp=' + df.data.timestamp +
                '&verification=' + df.data.verification +
                '&token=' + Session.isAuthenticated().toString()
        })
    }

    /**
     * 强制修改密码  2019-9-27
     */
    @action
    mustSetPassword = (loginValue) => {
        if (!loginValue) {
            this.modal = 'hide'
            return
        }
        const passwordStatus = loginValue.accountStatusCode
        const passwordTime = loginValue.accountRemainingTime
        if (passwordStatus === '2' || (passwordStatus === '3' && passwordTime <= '0')) {
            this.modal = 'show'
            // this.mustSet=true
        }
    }

    @action
    setLogin = (password) => {
        this.password=password
        this.isLogin = true
    }

    @action
    logoutBtn = () => {
        this.logout()
        this.cancelEdit()
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /**
     * 切换侧边栏折叠
     */
    @action
    toggle = () => {
        this.collapsed = !this.collapsed
    }

    /**
     * 添加标签页
     */
    @action
    addTabPane = (item) => {
        const panes = this.panes.slice();
        const activeKey = item.url;
        const test = item.url.split('/').pop()
        //如果标签页不存在就添加一个标签页
        const flag = !panes.find(i => i.key === activeKey)
        if (flag) {
            if (panes.length > 7) {
                panes.shift()
            }
            panes.push({title: item.name, content: test, key: activeKey});
        }
        this.panes = panes
        this.activeKey = activeKey
    }
    /**
     * 移除标签页
     */
    @action
    removePane = (targetKey) => {
        let activeKey = this.activeKey;
        let lastIndex;
        this.panes.find((pane, i) => {
            if (pane.key === targetKey) {
                lastIndex = i - 1;
            }
            return pane.key === targetKey         //提前结束遍历
        });
        const panes = this.panes.filter(pane => pane.key !== targetKey);

        if (activeKey === targetKey) {
            if (lastIndex >= 0) {
                activeKey = panes[lastIndex].key;
            } else {
                panes[0] && (activeKey = panes[0].key)
            }
        }
        this.selectedKeys = [activeKey]
        this.panes = panes
        this.activeKey = activeKey
        if (panes.length === 0) {
            this.selectedKeys = []
        }
    }
}

export default new AppStore()


// WEBPACK FOOTER //
// ./src/stores/appStore.js